/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './getEvent.defs.js'
export * as $defs from './getEvent.defs.js'
